export const contratMoneyRouter = [
  {
    path: "/projectPayment/contractMoney/list",
    name: "contract-money-list",
    meta: { title: "合同收款单" },
    component: () =>
      import(/* webpackChunkName: "contractMoney" */ "@/views/project-payment/contractMoney/list/index.vue"),
  },
  {
    hidden: true,
    path: "/projectPayment/contractMoney/create",
    name: "contract-money-create",
    meta: { title: "新增合同收款单",comName:"projectPaymentContractMoneyFormCreate" },
    component: () =>
      import(/* webpackChunkName: "contractMoney" */ "@/views/project-payment/contractMoney/form-create/index.vue"),
  },
  {
    hidden: true,
    path: "/projectPayment/contractMoney/edit/:id",
    name: "contract-money-edit",
    meta: { title: "编辑合同收款单",comName:"projectPaymentContractMoneyFormCreate" },
    component: () =>
      import(/* webpackChunkName: "contractMoney" */ "@/views/project-payment/contractMoney/form-create/index.vue"),
  },
  {
    hidden: true,
    path: "/projectPayment/contractMoney/detail/:id",
    name: "contract-money-detail",
    meta: { title: "合同收款单详情" },
    component: () =>
      import(
        /* webpackChunkName: "contractMoney" */ "@/views/project-payment/contractMoney/form-detail/index.vue"
      ),
  },
  {
    hidden: true,
    path: "/projectPayment/contractMoney/flowPrint/:id",
    name: "contract-flow-print",
    meta: { title: "打印详情" },
    component: () =>
      import(
        /* webpackChunkName: "contractMoney" */ "@/views/project-payment/contractMoney/flow-print/index.vue"
      ),
  },
];
